module.exports = __webpack_public_path__ + "static/media/game(25).3d2eadb8.PNG";